/**
 * Injects section headers/separators and prize descriptions into the
 * Shopify Forms app (which renders inside a Shadow DOM).
 *
 * Sections injected:
 *   - LOCATION          → before the Province dropdown
 *   - CHOOSE YOUR PRIZE → before "Which getaway would you like to win?"
 *   - TELL US ABOUT DAD → before "Which best describes the dad..."
 *   - COMPETITION QUESTION → before "Tell us about the dad or father figure..."
 *
 * Prize descriptions injected beneath each getaway radio option.
 */
(function () {

  // ─── Config ─────────────────────────────────────────────────────────────────

  var HOST_SELECTOR = "shopify-forms-embed";

  // Text to inject beneath each getaway radio option
  var PRIZE_DESCRIPTIONS = {
    "KwaZulu-Natal Experience": "Zebra Hills Safari Lodge (Jack's Cottage for 4 guests)",
    "Cape Town Experience":     "Abalone Hotel & Villas (Villa for 4 guests)"
  };

  // Section headers: each entry defines a marker to find the right place,
  // and the heading text to inject above it.
  // `markerType`  → "fieldset" matches fieldset[name="..."]
  //               → "legend"   matches a legend whose text contains `markerText`
  var SECTION_HEADERS = [
    {
      id:          "location-header",
      heading:     "LOCATION",
      markerType:  "fieldset",
      markerAttr:  'fieldset[name="custom#location"]',
      hasSeparator: false   // first section — no separator above it
    },
    {
      id:          "choose-prize-header",
      heading:     "CHOOSE YOUR PRIZE",
      markerType:  "fieldset",
      markerAttr:  'fieldset[name="custom#which_getaway_would_you_like_to_win"]',
      hasSeparator: true
    },
    {
      id:          "tell-us-dad-header",
      heading:     "TELL US ABOUT DAD",
      markerType:  "fieldset",
      markerAttr:  'fieldset[name="custom#which_best_describes_the_dad_or_father_figure_youre_nominating"]',
      hasSeparator: true
    },
    {
      id:          "competition-question-header",
      heading:     "COMPETITION QUESTION",
      // Textarea name is truncated by Shopify — use starts-with selector [name^=...]
      // useParent: true tells the injector to insert before the wrapper div, not the textarea itself
      markerAttr:  'textarea[name^="custom#tell_us_about_the_dad_or_father_figure_youd_love_to_spoil"]',
      useParent:   true,
      hasSeparator: true
    },
    {
      id:          "consent-header",
      heading:     "CONSENT",
      markerAttr:  'fieldset[name="custom#consent"]',
      hasSeparator: true
    }
  ];

  // ─── Helper: create a styled heading (and optional separator) ───────────────

  function createHeader(text, hasSeparator) {
    var frag = document.createDocumentFragment();

    if (hasSeparator) {
      var hr = document.createElement("hr");
      hr.style.border    = "none";
      hr.style.borderTop = "1px solid #e0e0e0";
      hr.style.margin    = "24px 0 16px";
      frag.appendChild(hr);
    }

    var p = document.createElement("p");
    p.textContent        = text;
    p.style.fontWeight   = "600";
    p.style.fontSize     = "0.85em";
    p.style.letterSpacing = "0.08em";
    p.style.textTransform = "uppercase";
    p.style.margin       = hasSeparator ? "0 0 16px" : "0 0 16px";
    p.style.color        = "#202020";
    frag.appendChild(p);

    return frag;
  }

  // ─── Main injection (runs against the shadow root) ───────────────────────────

  function injectAll(root) {
    var allDone = true;

    // 1. Section headers
    SECTION_HEADERS.forEach(function (section) {
      if (root.querySelector("#" + section.id)) return; // already injected

      var anchor = root.querySelector(section.markerAttr);
      if (!anchor) {
        console.log("[form-inject] Anchor not found yet for:", section.heading, "→", section.markerAttr);
        allDone = false;
        return;
      }

      // For textarea fields, the anchor is inside a wrapper div — insert before the wrapper
      var insertBefore = section.useParent ? anchor.parentNode : anchor;

      var frag = createHeader(section.heading, section.hasSeparator);

      // Mark the first element in the fragment so we can dedup
      var marker = document.createElement("span");
      marker.id = section.id;
      marker.style.display = "none";
      insertBefore.parentNode.insertBefore(marker, insertBefore);
      insertBefore.parentNode.insertBefore(frag, insertBefore);

      console.log("[form-inject] ✅ Header injected:", section.heading);
    });

    // 2. Prize descriptions beneath each getaway radio label
    var getawayFieldset = root.querySelector('fieldset[name="custom#which_getaway_would_you_like_to_win"]');
    if (getawayFieldset) {
      var labels = getawayFieldset.querySelectorAll("label");
      var descAdded = 0;

      labels.forEach(function (labelEl) {
        if (labelEl.getAttribute("data-desc-added") === "true") { descAdded++; return; }

        var labelText = (labelEl.textContent || "").trim();
        var key = Object.keys(PRIZE_DESCRIPTIONS).find(function (k) {
          return labelText === k || labelText.indexOf(k) !== -1;
        });
        if (!key) return;

        var span = document.createElement("span");
        span.className        = "getaway-prize-desc";
        span.textContent      = PRIZE_DESCRIPTIONS[key];
        span.style.display    = "block";
        span.style.marginTop  = "2px";
        span.style.marginLeft = "24px";
        span.style.fontSize   = "0.875em";
        span.style.color      = "#666";

        labelEl.insertAdjacentElement("afterend", span);
        labelEl.setAttribute("data-desc-added", "true");
        descAdded++;
        console.log("[form-inject] ✅ Prize description injected for:", key);
      });

      if (descAdded < Object.keys(PRIZE_DESCRIPTIONS).length) allDone = false;
    } else {
      allDone = false;
    }

    return allDone;
  }

  // ─── Watch a shadow root until everything is injected ────────────────────────

  function watchRoot(root) {
    if (injectAll(root)) {
      console.log("[form-inject] ✅ All injections complete");
      return;
    }

    var observer = new MutationObserver(function () {
      if (injectAll(root)) {
        console.log("[form-inject] ✅ All injections complete — disconnecting observer");
        observer.disconnect();
      }
    });
    observer.observe(root, { childList: true, subtree: true });

    setTimeout(function () {
      console.warn("[form-inject] 20s timeout — stopping observer");
      observer.disconnect();
    }, 20000);
  }

  // ─── Bootstrap: find the shadow host ────────────────────────────────────────

  function tryShadowHost() {
    var host = document.querySelector(HOST_SELECTOR);
    if (!host) return false;

    var shadow = host.shadowRoot;
    if (!shadow) {
      console.warn("[form-inject] shadowRoot is null (closed) — cannot inject");
      return false;
    }

    console.log("[form-inject] ✅ Shadow root found");
    watchRoot(shadow);
    return true;
  }

  console.log("[form-inject] Script initialising...");

  if (!tryShadowHost()) {
    var hostObserver = new MutationObserver(function () {
      if (tryShadowHost()) hostObserver.disconnect();
    });
    hostObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { hostObserver.disconnect(); }, 30000);
  }

})();